import script from "./ViewAttendance.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAttendance.vue?vue&type=script&setup=true&lang=js"

import "./ViewAttendance.vue?vue&type=style&index=0&id=147b8dc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-147b8dc6"]])

export default __exports__